export default __webpack_public_path__ + "static/backgroundEvento-444cac148eed0be8cc070fa3b778c991.png";